"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const mobx_1 = require("mobx");
const DEFAULT_CURRENCY_1 = __importDefault(require("../constants/date/DEFAULT_CURRENCY"));
const DIR_1 = __importDefault(require("../constants/lang/DIR"));
const LANG_1 = __importDefault(require("../constants/lang/LANG"));
/**  start-no-seo */
const seoMeta_1 = __importDefault(require("../constants/seo/seoMeta"));
const mapInitialStateToStoreState_1 = __importDefault(require("../utils/store/mapInitialStateToStoreState"));
class ConfigStore {
    constructor(initialState = {}) {
        this.data = {};
        /**
         * Method that returns page SEO meta data
         * @param {string} pageName
         * @returns {object}
         */
        this.getPageSEOMetaData = (pageName) => {
            return {
                title: (0, get_1.default)(seoMeta_1.default, `pages.${pageName}.title.${this.locale}`, ''),
                description: (0, get_1.default)(seoMeta_1.default, `pages.${pageName}.description.${this.locale}`, ''),
            };
        };
        // end of SEO meta data
        /** end-no-seo */
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.updateInitialState(initialState);
    }
    /**
     * Returns the current locale
     * @returns {String}
     */
    get locale() {
        return (0, get_1.default)(this.data, 'locale', LANG_1.default.AR);
    }
    /**
     * Returns the current direction
     * @returns {String}
     */
    get direction() {
        return (0, get_1.default)(this.data, 'direction', DIR_1.default.RTL);
    }
    /**
     * Returns the current currency
     * @returns {String}
     */
    get currency() {
        return (0, get_1.default)(this.data, 'currency', DEFAULT_CURRENCY_1.default);
    }
    /**
     * Returns if it is right to left
     * @returns {Boolean}
     */
    get isRtl() {
        return this.direction === DIR_1.default.RTL;
    }
    /**  start-no-seo */
    /**
     * Returns the Checkout.com Public Key
     * @returns {string}
     */
    get checkoutPayKey() {
        return (0, get_1.default)(this.data, 'checkoutPayKey', '');
    }
    /**
     * Returns the Google Recaptcha Site key
     * @returns {string}
     */
    get reCaptchaSiteKey() {
        return (0, get_1.default)(this.data, 'reCaptchaSiteKey', '');
    }
    /**
     * Returns Apple Pay merchant ID
     * Sandbox, prod environments
     * value comes from env var
     */
    get applePayMerchantId() {
        return (0, get_1.default)(this.data, 'applePayMerchantId', '');
    }
    /** end-no-seo */
    /**
     * Returns the application environment
     * For eg. staging, local, development, production
     * @returns {string}
     */
    get appEnv() {
        return (0, get_1.default)(this.data, 'appEnv', '');
    }
    /**
     * Returns the tag version
     * @returns {string}
     */
    get appVersion() {
        return (0, get_1.default)(this.data, 'appVersion', '');
    }
    /**
     * Returns device type
     * @returns {boolean}
     */
    get isMobile() {
        return (0, get_1.default)(this.data, 'isMobile', false);
    }
    /**  start-no-seo */
    // SEO meta data
    /**
     * Returns site wide SEO meta data
     * @returns {object}
     */
    get siteSEOMetaData() {
        return {
            siteTitle: (0, get_1.default)(seoMeta_1.default, `siteTitle.${this.locale}`, ''),
            siteDescription: (0, get_1.default)(seoMeta_1.default, `siteDescription.${this.locale}`, ''),
            social: (0, get_1.default)(seoMeta_1.default, 'social', {}),
        };
    }
}
__decorate([
    mobx_1.observable
], ConfigStore.prototype, "data", void 0);
__decorate([
    mobx_1.computed
], ConfigStore.prototype, "locale", null);
__decorate([
    mobx_1.computed
], ConfigStore.prototype, "direction", null);
__decorate([
    mobx_1.computed
], ConfigStore.prototype, "currency", null);
__decorate([
    mobx_1.computed
], ConfigStore.prototype, "isRtl", null);
__decorate([
    mobx_1.computed
], ConfigStore.prototype, "checkoutPayKey", null);
__decorate([
    mobx_1.computed
], ConfigStore.prototype, "reCaptchaSiteKey", null);
__decorate([
    mobx_1.computed
], ConfigStore.prototype, "applePayMerchantId", null);
__decorate([
    mobx_1.computed
], ConfigStore.prototype, "appEnv", null);
__decorate([
    mobx_1.computed
], ConfigStore.prototype, "appVersion", null);
__decorate([
    mobx_1.computed
], ConfigStore.prototype, "isMobile", null);
__decorate([
    mobx_1.computed
], ConfigStore.prototype, "siteSEOMetaData", null);
__decorate([
    mobx_1.action.bound
], ConfigStore.prototype, "updateInitialState", void 0);
exports.default = ConfigStore;
